module.exports = __webpack_public_path__ + "img/短信-3.6c64aa80.png";